export default __webpack_public_path__ + "static/media/lb-hackathon-level-3.0ad5a71b.svg";